import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=5f48e5f8&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=5f48e5f8&prod&lang=scss&scoped=true"
import style1 from "./chat.vue?vue&type=style&index=1&id=5f48e5f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f48e5f8",
  null
  
)

export default component.exports